export function formatBehaviorDisplay(behavior: string): string {
  return behavior
    .split("_")
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(" ");
}

export function isPositiveBehavior(behaviorFlag: string) {
  return behaviorFlag.toUpperCase() === "COMMUNITY";
}
